import {
  ACTIVATE_ACCOUNT_URL,
  CREATE_ACCOUNT_URL,
  APPROVE_ACCOUNT_URL,
  DEACTIVATE_ACCOUNT_URL,
  ACCOUNT_LIST_URL,
  REJECT_ACCOUNT_URL,
  VIEW_ACCOUNT_URL,
  VIEW_AGENT_ACCOUNT_URL,
  GET_WAKALA_ACCOUNT_DETAILS_URL,
} from "../../constant";
import { resourceRequest } from "../calls";

/* -------- ACCOUNTS ---------- */
export function doFetchAccount(token) {
  const data = {};
  return resourceRequest(token, ACCOUNT_LIST_URL, data);
}

export function doCreateAccount(token, data) {
  return resourceRequest(token, CREATE_ACCOUNT_URL, data);
}

export function doViewAccount(token, data) {
  return resourceRequest(token, VIEW_ACCOUNT_URL, data);
}

export function doActivateAccount(token, data) {
  return resourceRequest(token, ACTIVATE_ACCOUNT_URL, data);
}

export function doDeactivateAccount(token, data) {
  return resourceRequest(token, DEACTIVATE_ACCOUNT_URL, data);
}

export function doApproveAccount(token, data) {
  return resourceRequest(token, APPROVE_ACCOUNT_URL, data);
}

export function doRejectAccount(token, data) {
  return resourceRequest(token, REJECT_ACCOUNT_URL, data);
}

export function doViewAgentAccount(token, data) {
  return resourceRequest(token, VIEW_AGENT_ACCOUNT_URL, data);
}

export function doGetWakalaAccountDetails(token, data) {
  return resourceRequest(token, GET_WAKALA_ACCOUNT_DETAILS_URL, data);
}
